import { render, staticRenderFns } from "./imgDrag_echo.vue?vue&type=template&id=25120a61&scoped=true"
import script from "./imgDrag_echo.vue?vue&type=script&lang=js"
export * from "./imgDrag_echo.vue?vue&type=script&lang=js"
import style0 from "./imgDrag_echo.vue?vue&type=style&index=0&id=25120a61&prod&scoped=true&lang=scss"
import style1 from "./imgDrag_echo.vue?vue&type=style&index=1&id=25120a61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25120a61",
  null
  
)

export default component.exports